/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HealthStatusDto } from '../models/HealthStatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class HealthService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Healthcheck for endpoints in NextGenReservationService
     * @returns HealthStatusDto Success
     * @throws ApiError
     */
    public getApiHealth(): CancelablePromise<HealthStatusDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Health',
            errors: {
                500: `Server Error`,
            },
        });
    }

}
